import GridItem, { GridItemProps } from "@/components/data/table/GridItem"
import { Template } from "@/stores/template.store"
import { JSX } from "react"
import { Skeleton } from "@mantine/core"
import { store } from "@/stores/stores"
import { useNavigate } from "react-router"

interface TemplateGridItemProps extends GridItemProps<Template> {
  icon?: JSX.Element
}

function TemplateGridItem(props: TemplateGridItemProps) {
  const navigate = useNavigate()

  return (
    <GridItem
      {...props}
      to={`/scenarios/${props.item.id}?template=true`}
      className="min-h-40"
      animated
      replace
      onClick={() => {
        const existingCount = store.scenario.list.filter((x) => x.name === props.item.initialValues.name).length
        store.scenario.actions
          .create({
            ...props.item.initialValues,
            name: (props.item.initialValues.name || props.item.name) + (existingCount > 0 ? ` (${existingCount})` : ""),
          })
          .then((scenario) => {
            navigate(`/scenarios/${scenario.id}`, { replace: true })
          })
      }}
    >
      {props.loading ? (
        <Skeleton height={40} w={40} radius="circle" />
      ) : (
        <div className="size-10">{props.icon || <img src={props.item.image_src} alt={props.item.name} className="size-full" />}</div>
      )}
      <div className="mb-1 mt-3.5 truncate text-[17px] font-medium leading-6">
        {props.loading ? <Skeleton height={12} radius={"xl"} w={120} mt={12} /> : props.item.name}
      </div>
      {props.loading ? (
        <Skeleton height={8} radius={"xl"} w={160} mt={12} />
      ) : (
        <p className="text-md font-normal text-fg-secondary">{props.item.description}</p>
      )}
    </GridItem>
  )
}

export default TemplateGridItem
